import { InjectionToken } from '@angular/core';

import { HostAuthenticationService, HostAuthService } from './host-authentication.service';

export const HOST_AUTH_SERVICE = new InjectionToken<HostAuthService>(
  'HOST_AUTH_SERVICE',
  {
    factory: () => new HostAuthenticationService()
  }
);
